define([
	"dojo/_base/declare",
	"csi/table/NewFrom",
	"Apparel/StructureItemActionMixin"
], function(declare,NewFrom,StructureItemActionMixin) {

	return declare([NewFrom, StructureItemActionMixin], {
		_getFormView: function(/*Node*/node, /*Boolean*/bCheckOnly) {
			// summary: add special controller for New From form
			var	defView = this.inherited(arguments);
			this._mixinActionView(defView);
			return defView;
		}
	});
});